<template>
  <div>
    <div class="head-menu" style="padding:6px 8px;">
      <div>
        <span class="anm22-calendar-change-month-button" style="left:4px;" @click="prevYear()">&lt;</span>
        <span
          class="anm22-calendar-change-week-month"
        >{{ windowWidth >= 300 ? year.format('YYYY').toUpperCase(): year.format('YY').toUpperCase()}}</span>
        <span class="anm22-calendar-change-month-button" style="left:30px;" @click="nextYear()">&gt;</span>
      </div>
    </div>
    <div @click="returnToday()" class="today-label">
      <div class="name">{{$anm22.strLang(lang, 'Today', 'Oggi') }}</div>
    </div>
    <div class="vertical-height-div" style="height:5px;"></div>
    <div class="gantt-container">
      <div class="users-menu">
        <div
          v-for="(user, index) in allUsers"
          :class="['users-label']"
          :style="{height : newProjectsData(user).length > 1 ? 40 * parseInt(newProjectsData(user).length)  + 'px': '40px'  }"
          :title="user.name + ' ' + user.surname"
          :ref="'user-'+user.idWorldUser"
          :key="'user-'+index"
        >
          <img
            v-if="user.image !== '' || (user.fbId && user.fbId !== '' && user.fbId != 0)"
            :key="'u-'+index"
            :src="$anm22.getObjIcon(user, 'userDefault')"
            :title="user.name + ' ' + user.surname"
            class="user-icon"
          />
          <div
            v-else
            :key="'u-'+index"
            class="project-list-user user-round-div"
            :title="user.name + ' ' + user.surname"
          >{{ user.name.substring(0,1) + user.surname.substring(0,1) }}</div>
          <div
            :class="['users-name',,checkIsDeleted(user) ? 'block' : '']"
          >{{user.name + ' ' + user.surname}}</div>
        </div>
      </div>
      <div id="mapQ_canvas" class="container-map com-anm22-app-scrolling-panel">
        <div id="project-gant-scroll" :style="{ width: totalDaysInYear * 30 + 'px'}">
          <div class="today" :style="{left: leftFromData($moment().unix())  + 'px'}"></div>
          <div class="header">
            <div v-for="(element, index) in projectsGantt" :key="'grid-head-'+index">
              <div class="gantt-month">{{element.months.format("MMM YYYY").toUpperCase()}}</div>
              <div class="wg-row wg-day" style="flex-wrap:nowrap;">
                <div v-for="days in element.arrDays" class="day-list" :key="'days-'+days">{{ days }}</div>
              </div>
            </div>
          </div>
          <div v-for="(user, index) in allUsers" :key="'user-'+index">
            <div
              v-for="(lineProjects,index) in newProjectsData(user)"
              :key="'user-line'+index"
              :id="'user '+ user.idWorldUser + ' line ' + index"
              v-bind:style="{width: totalDaysInYear * 30 + 'px'} "
              class="user-line"
            >
              <template v-for="p in lineProjects">
                <router-link
                  v-if="lineProjects.length > 0"
                  :key="'project'+p.id"
                  :to="'/project/'+ p.id"
                  :class="['project',projectStyleClass(p),(isProjectStartBeforeYear(p))?'left-limit':'',(isProjectEndAfterYear(p))?'right-limit':'']"
                  :title="projectTitle(p)"
                  :style="{zIndex : zIndexByStatus(p), width: projectWidth(p) + 'px', left: leftFromData(p.startDate) + 'px'}"
                >
                  <img
                    v-if="p.urgent"
                    :src="$anm22.icons.getWorldIcon('priorityHighest')"
                    class="com-anm22-app-img-fixed-height-s"
                    style="display:inline-block;vertical-align:middle;"
                    :title="$anm22.tableClasses.taskPriority().getById(5)[lang]"
                  />
                  <img
                    v-if="!isSynchronized(p)"
                    :src="$anm22.icons.getWorldIcon('offline')"
                    class="com-anm22-app-img-fixed-height-s"
                    style="margin-left:5px;display:inline-block;vertical-align:middle;"
                    :title="$anm22.strLang(lang, 'Not synchronized', 'Non sincronizzato')"
                  />
                  <div class="project-code">{{ p.codeName }}</div>
                  
                </router-link>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    projectsData: {
      type: Array,
      required: true
    },
    workSelected: [Number, String]
  },
  data() {
    return {
      now: this.$moment(),
      yearOffset: 0
    };
  },
  components: {},
  computed: {
    ...mapState({
      windowWidth: state => state.windowWidth,
      user: state => state.auth.user,
      lang: state => state.lang
    }),
    users() {
      return this.$store.getters["users/getAll"];
    },
    year() {
      return this.now.clone().add(this.yearOffset, "years");
    },
    endYear() {
      let end = this.year.clone().endOf("year");
      return this.$moment(end).format("X");
    },
    startYear() {
      let start = this.year.clone().startOf("year");
      return this.$moment(start).format("X");
    },
    totalDaysInYear() {
      let startDay = this.year.clone().startOf("year");
      let endDay = this.year.clone().endOf("year");
      let totalDaysInYear = endDay.diff(startDay, "days");
      return totalDaysInYear + 1;
    },
    allUsers() {
      //Per ogni progetto prendo lo staff per andare a compilare la colonna del gantt
      let result = [];
      this.projectsData.forEach(project => {
        result = result.concat(project.users);
      });
      //Con new set elimino le ripetizioni
      result = [...new Set(result)];

      let users = result.map(u => this.$store.getters["users/get"](u));
      if (this.workSelected != "my") {
        //Ritorno gli utenti solo dell'azienda selezionata
        users = users.filter(u =>
          this.$store.getters["employments/get"](
            u.idWorldUser + "-" + this.workSelected
          )
        );
        //Inserisco gli utenti bloccati in fondo all'array degli utenti 
        let usersCopy = users.slice(0);
        usersCopy.forEach(u => {
          if (this.checkIsDeleted(u)) {
            let index = users.findIndex(us => us.idWorldUser == u.idWorldUser);
            users.splice(index, 1);
            users.push(u);
          }
        });
        return users;
      } else {
        return users;
      }
    },
    projectsGantt() {
      let result = [];
      let startDay = this.year.clone().startOf("year");
      let endDay = this.year.clone().endOf("year");
      let date = startDay.clone().subtract(1, "month");
      while (date.isBefore(endDay, "month")) {
        let months = date.add(1, "month").clone();
        let daysInMonth = months.daysInMonth();
        let arrDays = [];
        var i;
        for (i = 1; i <= daysInMonth; i++) {
          var current = i;
          arrDays.push(current);
        }
        result.push({
          months: months,
          daysInMonth: daysInMonth,
          arrDays: arrDays
        });
      }
      return result;
    }
  },

  methods: {
    isSynchronized(project) {
      return this.$store.getters["offline/isSynchronized"](
        this.$anm22.MD5("WorldProject" + project.id)
      );
    },
    returnToday() {
      this.yearOffset = 0;
      this.scroll();
    },
    checkIsDeleted(u) {
      if (this.workSelected != "my") {
        let employment = this.$store.getters["employments/get"](
          u.idWorldUser + "-" + this.workSelected
        );
        if (employment && employment.deleted === true) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    },
    newProjectsData(user) {
      let newArray = [];
      let projects = this.projectsByUser(user);
      projects.forEach(p => {
        let pDateStart = this.$moment.unix(p.startDate).format("YYYY-MM-DD");
        pDateStart = new Date(pDateStart);
        let pDateEnd = this.$moment.unix(p.deadline).format("YYYY-MM-DD");
        pDateEnd = new Date(pDateEnd);
        for (let i = 0; i <= newArray.length; i++) {
          if (!newArray[i]) {
            newArray.push([]);
          }
          let find = newArray[i].find(
            proj =>
              pDateStart <=
                new Date(
                  this.$moment.unix(proj.deadline).format("YYYY-MM-DD")
                ) &&
              pDateEnd >=
                new Date(this.$moment.unix(proj.startDate).format("YYYY-MM-DD"))
          );
          if (!find) {
            newArray[i].push(p);
            break;
          }
        }
      });
      if (newArray.length === 0) {
        return 1;
      }
      return newArray;
    },
    projectWidth(project) {
      let res = 0;
      if (
        project.deadline >= this.endYear &&
        project.startDate >= this.startYear
      ) {
        res = this.widthFromData(project.startDate, this.endYear);
      } else if (
        project.deadline >= this.endYear &&
        project.startDate <= this.startYear
      ) {
        res = this.widthFromData(project.startDate, this.endYear);
      } else {
        res = this.widthFromData(project.startDate, project.deadline);
      }
      return res;
    },
    projectsByUser(user) {
      return this.projectsData.filter(
        p =>
          p.users.includes(user.idWorldUser) &&
          p.startDate <= this.endYear &&
          p.deadline >= this.startYear
      );
    },
    projectJobs(project) {
      let licenses = project.developers
        .map(w => this.$store.getters["licenses/get"](w))
        .filter(l => l);
      let jobs =  licenses.reduce(
        (acc, license) =>
          acc.concat(
            license.config && license.config.tasks && license.config.tasks.jobs
          ),
        []
      );
      return Object.keys(project.jobs).map(pJob => jobs.find(j => j.id === pJob));

    },
    projectTitle(project){
      let usersNames = project.users.map( u => this.$store.getters['users/get'](u).name + ' ' + this.$store.getters['users/get'](u).surname);
      let licenses = project.developers
        .map(w => this.$store.getters["licenses/get"](w))
        .filter(l => l);
      let jobs =  licenses.reduce(
        (acc, license) =>
          acc.concat(
            license.config && license.config.tasks && license.config.tasks.jobs
          ),
        []
      );
      let projectJobsName = this.projectJobs(project).map( job =>job[this.lang])
      let string = project.codeName ;
      if(usersNames.length > 0) {
       string +=  '\n' + '- ' + usersNames.join('\n- ')
      }
      if(projectJobsName.length > 0) {
       string +=  '\n' + '- ' + projectJobsName.join('\n') 
      }
      return string;
    },
    zIndexByStatus(project) {
      switch (project.status) {
        case 1:
          return 5;
        case 2:
          return 6;
        case 3:
          return 3;
        case 4:
          return 2;
        case 5:
          return 1;
        case 6:
          return 4;
      }
    },
    projectStyleClass(project) {
      switch (project.status) {
        case 1:
          return "waiting";
        case 2:
          return "running";
        case 3:
          return "completed";
        case 4:
          return "invoiced";
        case 5:
          return "deleted";
        case 6:
          return "provisional";
      }
    },
    widthFromData(from, to) {
      var from = this.$moment.unix(from).format("YYYY-MM-DD");
      var to = this.$moment.unix(to).format("YYYY-MM-DD");
      let dateFrom = this.$moment(new Date(from));
      let dateTo = this.$moment(new Date(to));
      // Controllo che la fine non vada oltre l'anno
      if (
        parseInt(dateTo.format("YYYY")) > parseInt(this.year.format("YYYY"))
      ) {
        dateTo = this.$moment(this.year.format("YYYY") + "-12-31");
      }
      // Controllo che l'inizio non sia prima dell'anno
      if (
        parseInt(dateFrom.format("YYYY")) < parseInt(this.year.format("YYYY"))
      ) {
        dateFrom = this.$moment(this.year.format("YYYY") + "-01-01");
      }
      var diff = dateTo.diff(dateFrom, "days") + 1; //calcolo differenza giorni
      return this.daysToPixel(diff); //ritorno i giorni in pixel
    },
    leftFromData(from) {
      let dataFrom = this.$moment.unix(from).format("YYYY-MM-DD");
      let startYear = this.year.startOf("year").unix();
      startYear = this.$moment.unix(startYear).format("YYYY-MM-DD");
      startYear = this.$moment(new Date(startYear));
      let dateFrom = this.$moment(new Date(dataFrom));
      let diff = dateFrom.diff(startYear, "days") + 1;
      if (diff < 1) {
        diff = 1;
      }
      return this.dayToPosX(diff);
    },
    isProjectStartBeforeYear(project) {
      let yearInteger = parseInt(this.year.format("YYYY"));
      let projectStartYear = parseInt(
        this.$moment.unix(project.startDate).format("YYYY")
      );
      if (projectStartYear < yearInteger) {
        return true;
      } else {
        return false;
      }
    },
    isProjectEndAfterYear(project) {
      let yearInteger = parseInt(this.year.format("YYYY"));
      let projectEndYear = parseInt(
        this.$moment.unix(project.deadline).format("YYYY")
      );
      if (projectEndYear > yearInteger) {
        return true;
      } else {
        return false;
      }
    },
    dayToPosX(day) {
      return (day - 1) * 30;
    },
    daysToPixel(days) {
      return days * 30;
    },
    scroll() {
      let left = this.leftFromData(this.$moment().unix());
      document.getElementById("mapQ_canvas").scrollLeft = left - 30 * 2;
    },
    prevYear() {
      this.yearOffset--;
      document.getElementById("mapQ_canvas").scrollLeft = 11010;
    },
    nextYear() {
      this.yearOffset++;
      document.getElementById("mapQ_canvas").scrollLeft = 0;
    }
  },

  created() {},

  mounted() {
    setTimeout(
      function() {
        this.scroll();
      }.bind(this),
      1000
    );
  }
};
</script>
<style lang="scss" scoped>
.container-map {
  overflow-x: auto;
  overflow-y: hidden;
}
.block {
  color: red;
}
.today-label {
  padding: 5px 10px;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  cursor: pointer;
  background-color: #ddd;
  border-radius: 20px;
  margin: 0 0 0 10px;
}
.today-label .name {
  font-size: 15px;
  color: #222;
}
.today-label:hover {
  background-color: #ccc;
}
#project-gant-scroll {
  position: relative;
  overflow: hidden;
  background-position: 0px 0px;
  background-repeat: repeat;
  background-size: 25px auto;
}
.today {
  background-color: #eee;
  top: 22px;
  font-size: 13px;
  text-align: center;
  width: 30px;
  border-radius: 4px;
  position: absolute;
  height: 100000000000px;
}
.anm22-calendar-change-week-month {
  margin-left: 52px;
}
.user-icon {
  margin-left: 5px;
  vertical-align: middle;
  border-radius: 29px;
  width: 20px;
  height: 20px;
  display: inline-block;
}
.users-name {
  max-width: 100px;
  margin-left: 5px;
  vertical-align: middle;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
}
.user-line {
  position: relative;
  padding: 5px 0;
  height: 40px;
  box-sizing: border-box;
  font-size: 12px;
  cursor: default;
}
.gantt-container {
  background-color: #fff;
  border-radius: 6px;
}
.gantt-month {
  height: 22px;
  padding: 8px 4px 0 4px;
}
.users-menu {
  padding: 52px 0;
  float: left;
  border-right: 1px solid #eee;
  width: 155px;
}
@media screen and (max-width: 600px) {
  .users-menu {
    width: 40px;
  }
  .users-name {
    display: none;
  }
}

.users-label {
  width: 155px;
  font-size: 14px;
  display: inline-block;
  padding: 10px 5px 5px 5px;
  height: 40px;
  cursor: default;
  text-align: left;
  font-weight: normal;
  vertical-align: middle;
  box-sizing: border-box;
}
.head-menu {
  position: relative;
  vertical-align: middle;
  display: inline-block;
  height: 30px;
  box-sizing: border-box;
  line-height: 1;
  font-size: 18px;
}
.head-menu .anm22-calendar-change-month-button {
  top: 4px;
}
.wg-day {
  height: 30px;
  text-align: center;
  flex-wrap: nowrap;
}
.header {
  display: grid;
  -webkit-box-align: left;
  -ms-flex-align: left;
  align-items: left;
  text-align: left;
  font-size: 14px;
  grid-auto-flow: column;
}
.com-anm22-app-custom-scroll::-webkit-scrollbar,
.com-anm22-app-scrolling-panel::-webkit-scrollbar {
  height: 20px;
}
.project-code {
  vertical-align: middle;
  display: inline-block;
  margin-left: 5px;
}

.day-list {
  margin: auto;
  width: 30px;
  z-index: 10;
  cursor: default;
}
.header > div {
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: bold;
}

.day-list:last-child {
  color: red;
}

.project {
  height: 30px;
  box-sizing: border-box;
  border-radius: 20px;
  background-color: #ccc;
  position: absolute;
  white-space: nowrap;
  overflow: hidden;
  line-height: 1;
  font-size: 14px;
  padding: 5px;
  text-align: center;
  border: 2px solid #eee;
}
.project.waiting {
  background: #bdbdbd;
  border-color: #a3a3a3;
}
.project.running {
  background: #ffeb3b;
  border-color: #d6c100;
}
.project.completed {
  background: #01d479;
  border-color: #01a25c;
}
.project.invoiced {
  background: #00b0ff;
  border-color: #008bcc;
}
.project.deleted {
  background: #ff0000;
  border-color: #cc0000;
}
.project.provisional {
  background: #ffffff;
  border-color: #ffffff;
}
.project.left-limit {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
}
.project.right-limit {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 0;
}
div.job-icon {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: #007fff;
  border-radius: 50%;
  user-select: none;
  font-size: 14px;
}
.job-icon {
  width: 100%;
  height: 100%;
  padding: 0;
}
</style>